// Estado de cada etiqueta no menu "Gerenciar etiquetas" das ações em massa:
//   'all'  — todas as conversas selecionadas têm (caixa marcada)
//   'some' — só algumas têm (caixa parcial, com traço)
//   'none' — nenhuma tem
// Antes o menu só conhecia 'all': etiqueta presente em parte da seleção
// aparecia desmarcada e não havia como retirá-la em massa.
export const LABEL_STATE = { ALL: 'all', SOME: 'some', NONE: 'none' };

export const getLabelStates = conversations => {
  const total = conversations.length;
  if (!total) return {};

  const counts = {};
  conversations.forEach(conversation => {
    new Set(conversation.labels || []).forEach(label => {
      counts[label] = (counts[label] || 0) + 1;
    });
  });

  return Object.fromEntries(
    Object.entries(counts).map(([label, count]) => [
      label,
      count === total ? LABEL_STATE.ALL : LABEL_STATE.SOME,
    ])
  );
};

export const getCommonConversationLabels = conversations =>
  Object.entries(getLabelStates(conversations))
    .filter(([, state]) => state === LABEL_STATE.ALL)
    .map(([label]) => label);

// Ciclo de um clique: vazia ↔ marcada; parcial → marcada → vazia → parcial
// (voltar ao parcial = "não mexer nessa etiqueta").
export const nextLabelState = (current, initial) => {
  if (current === LABEL_STATE.ALL) return LABEL_STATE.NONE;
  if (current === LABEL_STATE.SOME) return LABEL_STATE.ALL;
  return initial === LABEL_STATE.SOME ? LABEL_STATE.SOME : LABEL_STATE.ALL;
};

// Só vira mudança o que o usuário levou a um estado diferente do inicial:
// 'all' = pôr em todas, 'none' = tirar de todas, 'some' = não mexer.
export const buildLabelChanges = (initialStates, currentStates) => {
  const labels = new Set([
    ...Object.keys(initialStates),
    ...Object.keys(currentStates),
  ]);
  const initialOf = label => initialStates[label] || LABEL_STATE.NONE;
  const currentOf = label => currentStates[label] || LABEL_STATE.NONE;

  const changed = [...labels].filter(
    label => currentOf(label) !== initialOf(label)
  );
  return {
    add: changed.filter(label => currentOf(label) === LABEL_STATE.ALL),
    remove: changed.filter(label => currentOf(label) === LABEL_STATE.NONE),
  };
};

// Aplicadas (todas, depois parciais) primeiro; o resto na ordem original.
export const sortLabelsByState = (labels, states) => {
  const rank = label => {
    const state = states[label.title];
    if (state === LABEL_STATE.ALL) return 0;
    if (state === LABEL_STATE.SOME) return 1;
    return 2;
  };
  return labels
    .map((label, index) => ({ label, index }))
    .sort((a, b) => rank(a.label) - rank(b.label) || a.index - b.index)
    .map(({ label }) => label);
};
